import React from 'react';
import { useParams } from 'react-router-dom';

const withParams = WrappedComponent => {
  function WithParams(props) {
    const params = useParams();
    return <WrappedComponent {...props} params={params} />;
  }
  WithParams.displayName = `withParams(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithParams;
};

export default withParams;
